<template>
    <div class="main">

        <el-tabs type="border-card">

            <el-tab-pane label="FASES DE MATRÍCULA">
                
                <el-row :gutter="30" class="u-mt-10 u-mb-20">
                    <el-col :xs="24" :sm="8" :md="8">
                        
                        <div class="container-fases-matricula">
                            <div class="titulo">PRIMEIA FASE</div>
                            <p>Renovação de matrícula para os alunos da rede</p>
                            <p>
                                <i>Ao executar esta rotina, um novo período letivo será criado e todas as matrículas ativas terão o seu status modificados
                                de ativos para pendentes. Esta rotina deverá ser executada apenas ao final e início de um novo período letivo.</i>
                            </p>

                            <el-button class="btn-fases-matricula" type="info" v-if="fase_matricula" round disabled>INICIAR</el-button>
                            <el-button @click="dialogPrimeiraFase = true" class="btn-fases-matricula" type="success" v-if="!fase_matricula" round>INICIAR</el-button>
                        </div>

                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        
                        <div class="container-fases-matricula">
                            <div class="titulo">SEGUNDA FASE</div>
                            <p>Matrícula dos alunos egressos</p>
                            <p class="descricao">
                                <i>O sistema ficará apto para o início da segunda fase de matrícula. A opção de nova matrícula será habilitada.
                                    A opção de renovação, da primeira fase, continua habilitada.
                                </i>
                            </p>

                            <el-button class="btn-fases-matricula" type="info" v-if="!fase_matricula || fase_matricula != 1" round disabled>INICIAR</el-button>
                            <el-button @click="initSegundaFase()" class="btn-fases-matricula" type="success" v-if="fase_matricula && fase_matricula == 1" round>INICIAR</el-button>

                        </div>

                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        
                        <div class="container-fases-matricula">
                            <div class="titulo">TERCEIRA FASE</div>
                            <p>Matrícula dos alunos de fora da rede municipal de educação</p>
                            <p>
                                <i>Ao executar esta rotina, todas as matrículas com o status pendente, ou seja, que não foram renovadas, serão 
                                    modificadas para o status concluída e o sistema possibilitará a matrícula de alunos de fora da rede.</i>
                            </p>

                            <el-button class="btn-fases-matricula" type="info" v-if="!fase_matricula || fase_matricula != 2" round disabled>INICIAR</el-button>
                            <el-button @click="initTerceiraFase()" class="btn-fases-matricula" type="success" v-if="fase_matricula && fase_matricula == 2">INICIAR</el-button>

                        </div>

                    </el-col>
                </el-row>
                

            </el-tab-pane>

            <el-tab-pane label="PERÍODOS LETIVOS ANTERIORES">

                <el-row class="u-mt-10 u-mb-20">
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-input v-model="filtro['nome']" placeholder="Pesquisar Período Letivo..." @keyup.native.enter="loadingPeriodos"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                        <el-button @click="storeNovoPeriodoLetivo()" type="primary">NOVO PERÍODO</el-button>
                    </el-col>
                </el-row>
                <div class="container-table">
                    <table v-loading="!statusList" class="table table-striped">
                        <thead>
                            <tr>
                                <th class="hidden-mobile" style="width: 70px;">cod</th>
                                <th>Nome</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="hidden-mobile">{{ item.id }}</td>
                                <td>{{ item.nome | truncate(30, '...') }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr v-if="statusList && items.length == 0" style="border-top: 1px solid #ddd;">
                                <td colspan="100%" class="u-text-center">
                                    <span>- nenhum registro -</span>
                                </td>
                            </tr>
                            <tr v-if="qtdItens > 10">
                                <td colspan="100%" class="u-text-right">
                                    <el-pagination :total="qtdItens" @current-change="getPagePagination" :page-size="10" background layout="prev, pager, next" small></el-pagination>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

            </el-tab-pane>
        </el-tabs>

        <el-dialog :close-on-click-modal="false" title="DADOS DO PERÍODO LETIVO" width="70%" top="5vh" :visible.sync="dialogPrimeiraFase">
            <el-form v-if="dialogPrimeiraFase" @submit.native.prevent="initPrimeiraFase" style="min-height: 200px;" :model="dados" ref="dados" label-position="top">

                <div class="alert-periodo-letivo">
                    <el-alert type="info" show-icon :closable="false">
                        <span style="font-size: 14px;">
                            Um período letivo será criado para cada instituição. 
                            Posteriormente, você poderá personalizar as datas de início e término e a quantidade de dias letivos no cadastro de cada instituição.  
                        </span>
                    </el-alert>
                </div>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Data de Início do Período" prop="data_inicial" :rules="[$requiredBlur]" key="data_inicial">
                            <el-input v-model="dados.data_inicial" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_inicial', 10)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Data de Término do Período" prop="data_final" :rules="[$requiredBlur]" key="data_final">
                            <el-input v-model="dados.data_final" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_final', 10)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Quantidade de Dias Letivos" prop="qtd_dias_letivos" :rules="[$requiredBlur]" key="qtd_dias_letivos">
                            <el-input v-model="dados.qtd_dias_letivos" maxlength="191" v-mask="'###'" v-on:blur="formatData('qtd_dias_letivos')"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
        
            </el-form>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data: () => ({
        dialogPeriodo: false,
        dialogPrimeiraFase: false,
        statusList: false,
        filtro: {
            nome: ''
        },
        page: 1,
        qtdItens: null,
        items: [ ],
        fase_matricula: '',
        formPeriodoLetivo: {
            id: '',
            nome: ''
        },
        dados: {
            id: '',
            data_inicial: '',
            data_final: '',
            qtd_dias_letivos: ''
        }
    }),
    mounted () {

        this.loadingPeriodos();
        this.getParametros();
    },
    methods: {
        storeNovoPeriodoLetivo(){

            this.$msgbox.confirm('Tem certeza que deseja criar um novo período letivo?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/periodo-letivo/store`, {}, this.$store.getters.getHeaderAuth).then(response => {
                        
                    
                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.dialogPeriodo = false;
                        this.loadingPeriodos();
                        this.getParametros();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        initPrimeiraFase(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                this.$msgbox.confirm('Tem certeza que deseja iniciar a primeira fase de matrícula?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                    window.eventBus.$emit('loading', true);
                        
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/sistema/initPrimeiraFaseMatricula`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                                
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.dialogPrimeiraFase = false;
                        this.loadingPeriodos();
                        this.getParametros();

                        if(typeof response.data.erro === 'undefined'){

                            setTimeout(()=>{
                                
                                this.$alert(response.data.matriculas + ' matrículas foram reaproveitadas', 'Sucesso!', { confirmButtonText: 'OK' });
                            
                            }, 1000);

                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }).catch(()=>{});

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        initSegundaFase(){

            this.$msgbox.confirm('Tem certeza que deseja iniciar a segunda fase de matrícula?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sistema/initSegundaFaseMatricula`, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(response.data){

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getParametros();
                    
                    }else{

                        window.eventBus.$emit('alert', {msg: 'Erro ao iniciar segunda fase de matrícula.', type: 'warning'});
                    }

                    window.eventBus.$emit('loading', false);


                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        initTerceiraFase(){

            this.$msgbox.confirm('Tem certeza que deseja iniciar a terceira fase de matrícula?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sistema/initTerceiraFase`, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(response.data){

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getParametros();
                    
                    }else{

                        window.eventBus.$emit('alert', {msg: 'Erro ao iniciar a terceira fase de matrícula.', type: 'warning'});
                    }

                    window.eventBus.$emit('loading', false);


                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        loadingPeriodos(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/periodo-letivo/getAllPaginate?page=` + this.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.qtdItens = response.data.total;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getParametros(){

            this.statusList = false;
            this.items = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro/get`, this.$store.getters.getHeaderAuth).then(response => {

                this.fase_matricula = response.data.fase_matricula;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deletePeriodo(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir este período letivo?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/periodo-letivo/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingPeriodos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.page = page;
          this.loadingPeriodos();
        },
        formatData(field, size = null){
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    }
}
</script>
<style>

.container-fases-matricula{

    border: 1px solid #ccc; 
    padding: 20px; 
    height: 500px; 
    display: flex; 
    justify-content: center; 
    flex-direction: column; 
    align-items: center;
}

.container-fases-matricula .titulo {

    display: flex; 
    justify-content: center; 
    font-weight: bold; 
    font-size: 20px;
}

.container-fases-matricula p{
    text-align: center
}

.container-fases-matricula .btn-fases-matricula{
    margin-top: 20px;
    border-radius: 100px; 
    height: 150px;
    width: 150px;
    font-size: 18px;
}

.container-fases-matricula .descricao {
    min-height: 84px;
}

.alert-periodo-letivo{
    margin: 30px 0px;
}

</style>